export default __webpack_public_path__ + "static/media/iconPlusBlack.55c68c60.svg";